import './error.page.scss';

import { Paper, Typography } from '@mui/material';

import { Box } from '@mui/system';
import { ConvergeButton } from '@converge/ui';
import { config } from '@converge/config';

interface Props {
  message: string;
  retry: () => Promise<void> | void;
  isRetrying: boolean;
  retryLabel: string;
  id: string;
}

export const ErrorPage = ({
  message = 'Error',
  retry,
  retryLabel,
  isRetrying,
  id,
}: Props) => {
  return (
    <Paper
      elevation={5}
      id={`error-page-for-${id}`}
      className="paperStyle error-page"
    >
      <Box className="box-container">
        <img src={config.logo} alt="logo" className="logoImage" />
      </Box>
      <Box className="box-container">
        <Typography variant="h4">{message}</Typography>
      </Box>
      <Box className="box-container">
        <ConvergeButton
          onClick={() => retry()}
          variant="contained"
          loading={isRetrying}
          aria-label="Retry"
          label={retryLabel}
        />
      </Box>
    </Paper>
  );
};
